// extracted by mini-css-extract-plugin
export default {"img2":"DuplicatesPreviewVariant3__img2--34ff_","img3":"DuplicatesPreviewVariant3__img3--3B1Ch"};